import React from 'react'
import { Redirect, Route } from 'react-router-dom'

// Allows access if logged in as STAFF_SERVER or STAFF_MANAGER
export const StaffPrivateRoute = ({ component: Component, allowedRoles, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const raw = localStorage.getItem('staff-session')
      if (!raw) return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />
      try {
        const session = JSON.parse(raw)
        if (!allowedRoles || allowedRoles.includes(session.role)) {
          return <Component {...props} />
        }
        return <Redirect to="/" />
      } catch {
        return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />
      }
    }}
  />
)
